export default "__VITE_ASSET__jBkJTVIC__"